export const filterByteToSize = (bytes: number): string => {
  const sizes = ['байт', 'кБ', 'МБ', 'ГБ', 'ТБ']
  if (bytes === 0) return '0 байт'
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i]
}
